import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { RoundShape } from "../Assets";
import { GoPeople } from "react-icons/go";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { BiSolidPlaneTakeOff } from "react-icons/bi";
import { PiSolarPanel } from "react-icons/pi";
import { SiBmcsoftware } from "react-icons/si";
import { FaBuilding } from "react-icons/fa";
import { MdSchool } from "react-icons/md";
import { AiOutlineProject } from "react-icons/ai";

const Features = () => {
  const [show, setShow] = useState(false);
  const [selectedFtrs, setselectedFtrs] = useState({
    id: 0,
    icon: null,
    topic: "",
    content: "",
    bgColor: "",
  });

  const handleModal = (value) => {
    setShow(true);
    setselectedFtrs({
      id: value.id,
      icon: value.icon,
      topic: value.topic,
      content: value.content,
      bgColor: value.bgColor,
    });
  };

const FeaturesArray = [

  {
    id: 1,
    icon: <FaBuilding className="fw-800 fs-3" />,
    bgColor: "bg-6bc5e3",
    topic: "Apartment Management",
    content:
      "Efficiently manage residents, billing, maintenance, and security operations in one unified platform.",
  },
  {
    id: 2,
    icon: <MdSchool className="fw-800 fs-3" />,
    bgColor: "bg-8bc34a",
    topic: "LMS (Learning Management System)",
    content:
      "Deliver, track, and manage educational content with powerful tools for learners and instructors.",
  },
  {
    id: 3,
    icon: <AiOutlineProject className="fw-800 fs-3" />,
    bgColor: "bg-ff9800",
    topic: "Project Management",
    content:
      "Plan, execute, and monitor projects with real-time collaboration and performance tracking.",
  },

  
  {
    id: 4,
    icon: (
      <span>
        <IoIosArrowBack className="fw-800 fs-4" style={{ marginRight: "-3px" }} />
        <IoIosArrowForward className="fw-800 fs-4" style={{ marginLeft: "-3px" }} />
      </span>
    ),
    bgColor: "bg-f78acb",
    topic: "Cybersecurity Solutions",
    content:
      "Fortify your digital world with advanced security solutions, safeguarding what matters most",
  },
  {
    id: 5,
    icon: <BiSolidPlaneTakeOff className="fw-800 fs-3" />,
    bgColor: "bg-c679e3",
    topic: "Charter Aviation & Aircraft Maintenance",
    content:
      "Empowering charter aviation with seamless navigation and data-driven decisions",
  },
  {
    id: 6,
    icon: <PiSolarPanel className="fw-800 fs-3" />,
    bgColor: "bg-eb6b3d",
    topic: "Solar Investments",
    content:
      "Powering a sustainable future - From energy outputs to revenue collections - every insight, in one place.",
  },
  {
    id: 7,
    icon: <GoPeople className="fw-800 fs-3" />,
    bgColor: "",
    topic: "Customer Support",
    content:
      "Our in-house support platform ensures efficient case management, faster response times, and proactive service delivery.",
  },
  {
    id: 8,
    icon: <SiBmcsoftware className="fw-800 fs-3" />,
    bgColor: "bg-f1d34f",
    topic: "Custom Software Development",
    content: "Tailored tech for your unique needs",
  },
];
  return (
    <>
      <div className="solutions-area ptb-50" id="features">
        <div className="container">
          <div className="section-title">
            <span className="sub-title">What We Offer</span>
            <h2>Our Featured Solutions</h2>
            <div className="bar"></div>
            <p>
              Commitment to providing exceptional services that drive success
              and innovation.
            </p>
          </div>

          <div className="row justify-content-center ftrs">
            {FeaturesArray.map((item) => (
              <div
                className="col-lg-4 col-md-12 col-sm-12 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1200"
                data-aos-once="false"
                key={item.id}
              >
                <button
                  className={`single-box ${item.bgColor}`}
                  key={item.id}
                  style={{
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    height: "270px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingTop: "30px",
                  }}
                  onClick={() => handleModal(item)}
                >
                  <div className="icon">{item.icon}</div>
                  <h3>{item.topic}</h3>
                  <p>{item.content}</p>
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="shape1">
          <img src={RoundShape} alt="shape11" />
        </div>
        <div className="shape2 rotateme">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
            alt="shape"
          />
        </div>
        <div className="shape3">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC41NjIiIGhlaWdodD0iMjguNTk0IiB2aWV3Qm94PSIwIDAgMjguNTYyIDI4LjU5NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICNlMWUxZTE7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAzcHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTQuMjgxIiBjeT0iMTQuMjk3IiByPSIxMi43ODEiLz4KPC9zdmc+Cg=="
            alt="shape"
          />
        </div>
        <div className="shape4">
          <img
            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
            alt="shape"
          />
        </div>
        <div className="shape7">
          <img
            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
            alt="shape"
          />
        </div>
        <div className="shape8 rotateme">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
            alt="shape"
          />
        </div>
      </div>
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Dialog className="modal-dialog-custom">
          <div className="modal-content-custom">
            <Modal.Header closeButton className="modal-header-custom">
              {/* <Modal.Title>Admin - {selectedProduct.date}</Modal.Title> */}
            </Modal.Header>

            <Modal.Body className="modal-body-custom">
              <div className={`${selectedFtrs.bgColor}`}>
                <div className="icon">{selectedFtrs.icon}</div>
                <br />
                <br />
                <h3>{selectedFtrs.topic}</h3>
                <p>{selectedFtrs.content}</p>
              </div>
            </Modal.Body>
          </div>
        </Modal.Dialog>
      </Modal>
    </>
  );
};

export default Features;
